import accountReducerMap from 'wanderu-ducks-account';

import StationGuide from '../containers/StationGuide';
import reducerMap from '../ducks';

function onLoad(module, info, props, context) {
    context.store.inject({
        ...reducerMap,
        ...accountReducerMap,
    });
}

export { onLoad };
export default StationGuide;
